"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Navigation", {
    enumerable: true,
    get: function() {
        return Navigation;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _components = require("@cmpsr/components");
var _components1 = require("./components/index");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Navigation = function(_param) {
    var _param_sticky = _param.sticky, sticky = _param_sticky === void 0 ? false : _param_sticky, _param_keepActionsAlwaysVisible = _param.keepActionsAlwaysVisible, keepActionsAlwaysVisible = _param_keepActionsAlwaysVisible === void 0 ? false : _param_keepActionsAlwaysVisible, children = _param.children, props = _object_without_properties(_param, [
        "sticky",
        "keepActionsAlwaysVisible",
        "children"
    ]);
    var showBaseNavigation = (0, _components.useBreakpointValue)({
        base: true,
        lg: false
    });
    var scrollPosition = (0, _components.useScrollPosition)();
    var image = null;
    var links = null;
    var actions = null;
    _react.Children.map(children, function(child) {
        if ((0, _react.isValidElement)(child)) {
            switch(child.type){
                case _components1.NavigationImage:
                    image = child;
                    break;
                case _components1.NavigationLinks:
                    links = child;
                    break;
                case _components1.NavigationActions:
                    actions = child;
                    break;
            }
        }
    });
    return _react.default.createElement(_components1.NavigationProvider, {
        value: {
            showBaseNavigation: showBaseNavigation,
            keepActionsAlwaysVisible: keepActionsAlwaysVisible
        }
    }, _react.default.createElement(_components.Flex, _object_spread({
        as: "nav",
        bg: "background-page",
        py: {
            base: "0.75rem",
            lg: "1.5rem"
        },
        px: {
            base: "1rem",
            lg: "2.75rem"
        },
        alignItems: "center",
        gap: "0.75rem",
        minHeight: {
            base: "4.75rem",
            lg: "5rem"
        },
        transition: "box-shadow ease-in-out .15s;",
        zIndex: 1
    }, sticky && {
        position: "sticky",
        top: 0
    }, scrollPosition && {
        boxShadow: "elevation-interactive"
    }, props), (0, _react.cloneElement)(links, {
        actions: actions,
        image: image
    })));
};
Navigation.Image = _components1.NavigationImage;
Navigation.Links = _components1.NavigationLinks;
Navigation.Link = _components1.NavigationLink;
Navigation.Actions = _components1.NavigationActions;
Navigation.Action = _components1.NavigationAction;
